import axios from 'axios'


const jwt = window.localStorage.getItem('jwt')
axios.defaults.headers.common = { 'Authorization': `Bearer ${jwt}` }

export default axios